// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__24Rim","col":"CardReaderDesc_col__2WkFN","label":"CardReaderDesc_label__1nnrO"};